import { $window, $body, Breakpoints } from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';
import NextCourse from './NextCourse';

/**
 * NextCourses
 */
const NextCourses = (() => {
  // Constants
  const DATA_KEY = 'ig.next-courses';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    NEXT_COURSES: '.todays_courses',
    COURSE: '.tt_course'
  };

  /**
   * ClassName
   *
   * @var { Object }
   */
  const ClassName = {
    CARDS: 'todays-courses-cards',
    LOADED: 'loaded',
    EQUALIZED: 'equalized'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`,
    COURSE_CLICK: `click.course${EVENT_KEY}`
  };

  /**
   * NextCourses
   *
   * @class
   * @augments HtmlElement
   */
  class NextCourses extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._ajaxUrl = this.$element.data('ajax-url');
      this.$element.removeAttr('data-ajax-url');

      this._fetchCourses(() => {
        this._courses = this._getCourses();
        if ($window.width() >= Breakpoints.MEDIUM) {
          this._equalizeCourses();
        } else {
          this._removeEqualizer();
        }
      });

      this._bindHandlers();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        if ($window.width() >= Breakpoints.MEDIUM) {
          this._equalizeCourses();
        } else {
          this._removeEqualizer();
        }
      });
    }

    /**
     * Returns the courses
     *
     * @return { Array } courses
     */
    _getCourses() {
      let courses = [];

      this.$element.find(Selector.COURSE).each((i, el) => {
        let course = new NextCourse($(el), this);

        course.onReady();
        courses.push(course);
      });

      return courses;
    }

    /**
     * Fetches the courses with the url and loads them into the html element
     *
     * @param { Function } callblack
     * @return void
     */
    _fetchCourses(callback) {
      $.ajax({
        url: this._ajaxUrl
      }).done((html) => {
        if (html) {
          let $container;

          if (this.$element.hasClass(ClassName.CARDS)) {
            $container = this.$element.find('> .row');
          } else {
            $container = this.$element;
          }

          $container.html(html);

          if (typeof callback === 'function') {
            callback();
          }

          this.$element.addClass(ClassName.LOADED);
        }
      });
    }

    /**
     * Equalizes the courses
     *
     * @return void
     */
    _equalizeCourses() {
      let heights = [];

      this._courses.forEach((course) => {
        heights.push(course.getHeight());
      });

      this._setCourseHeights(Math.max(...heights));
      this.$element.addClass(ClassName.EQUALIZED);
    }

    /**
     * Removes the equalizer from the courses
     *
     * @return void
     */
    _removeEqualizer() {
      this._setCourseHeights('');
      this.$element.removeClass(ClassName.EQUALIZED);
    }

    /**
     * Sets the heights of all courses
     *
     * @param { int } height
     * @return void
     */
    _setCourseHeights(height) {
      this._courses.forEach((course) => {
        course.setHeight(height);
      });
    }
  }

  return NextCourses._getElements($body.find(Selector.NEXT_COURSES), NextCourses);
})();

export default NextCourses;
